export interface UploadFileEntity {
    id: number;
    projectId: number;
    userId: number;
    uuid: string;
    path: string;
    size: number;
    completed: boolean;
    insertionDate: string;
    modifiedDate: string;
    expiryDate: string;
    token: string;
}

export class UploadFile {
    id: number;

    projectID: number;

    userID: number;

    uuid: string;

    path: string;

    size: number;

    completed: boolean;

    creationDate: Date;

    lastModifiedDate: Date;

    expirationDate: Date;

    token: string;

    constructor(entity: UploadFileEntity) {
        this.id = entity.id;
        this.projectID = entity.projectId;
        this.userID = entity.userId;
        this.uuid = entity.uuid;
        this.path = entity.path;
        this.size = entity.size;
        this.completed = entity.completed;
        this.creationDate = new Date(entity.insertionDate);
        this.lastModifiedDate = new Date(entity.modifiedDate);
        this.expirationDate = new Date(entity.expiryDate);
        this.token = entity.token;
    }
}
